<template>
    <div class="connectionContainer">
        <!-- <div v-show="!this.$store.state.loading && !this.$store.state.successful"> -->
            <div class="connectionHeader">
                <!-- 集計名   -->
                <div class="totallingTargetInfo">
                    <input class="searchInputText" type="text" placeholder="商品グループ名" v-model="totallingTarget.name">
                </div>
                <div>
                    商品グループ名の入力・集計対象の商品を選択してください。
                </div>
            </div>
            <div class="connectionContents">
                <!-- 対象商品 -->
                <div class="productListPanel totallingTargetList">
                    <div class="totallingTargetList__title">集計対象</div>
                    <div class="productList">
                        <draggable class="productList__wrap"
                            v-model="totallingTarget.products"
                            @start="itemDraged = true"
                            @end="itemDraged = false"
                            animation="200"
                            group="description"
                            :disabled="false"
                            ghost-class="ghost"
                            handle=".productList__item-handle"
                        >
                            <transition-group tag="ul" class="productList__list"
                                :class="itemDraged ? 'draged' : ''"
                                type="transition" :name="!itemDraged ? 'flip-list' : null"
                            >
                                <li
                                    class="productList__item"
                                    v-for="product in totallingTarget.products" :key="product.id"
                                >
                                    <div class="productList__item-handle"><Icon>drag</Icon></div>
                                    <div class="productList__item-id">【{{ product.id }}<Icon v-if="product.is_set_product" title="セット商品">dice-multiple-outline</Icon>】</div>
                                    <div class="productList__item-name">{{ product.name }}</div>
                                    <div class="productList__item-action" @click="delProduct(product)"><Icon>close-circle</Icon></div>
                                </li>
                            </transition-group>
                        </draggable>
                        <div v-if="totallingTarget.products.length == 0" class="productListNotFound">
                            <p>商品グループが設定されてません。</p>
                            <p>設定してないまま更新すると削除されます。</p>
                        </div>
                    </div>
                </div>
                <!-- 未紐付け 商品 -->
                <div class="productListPanel selectProductList">
                    <ProductList
                        :list-column="1"
                        return-object
                        with-set-products
                        :add-fetch-parameters="{ with_totalling: true }"
                        :custom-filter="productListFilter"
                        @input="addProduct"
                    >
                        <template v-slot:header-action>
                            <label class="selectProductList__isTotallingTargetUsed">
                                <Checkbox v-model="isTotallingTargetUsed" x-small />
                                未登録商品を表示
                            </label>
                        </template>
                        <template v-slot:list-item-action>
                            <Icon class="productItemAction">plus-circle</Icon>
                        </template>
                    </ProductList>
                </div>
            </div>
            <div class="connectionFooter">
                <Button width="100px" @click="updateTotallingTargetItem">更新</Button>
            </div>
        </div>
    <!-- </div> -->
</template>

<script>
import ProductList from '@/components/ProductList.vue';
import draggable from 'vuedraggable';

export default {
    name: 'TheTotallingTargetItem',
    components: {
        ProductList,
        draggable,
    },
    props: {
        // 0: 新規登録
        totallingTargetId: Number
    },
    data() {
        return {
            totallingTarget: {
                id: null,
                name: "",
                products: [],
            },
            isTotallingTargetUsed: true,
            itemDraged: false,
        }
    },
    computed: {
    },
    mounted: function() {
        if (this.totallingTargetId > 0) {
            this.fetchTotallingTarget();
        }
    },
    methods: {
        fetchTotallingTarget: async function() {
            this.$store.dispatch('loading', true);

            const res = await this.axios.get(`/api/totallingTargets/${this.totallingTargetId}`);
            this.totallingTarget = res.data;

            this.$store.dispatch('loading', false);
        },
        addProduct(product) {
            this.totallingTarget.products.push(product);
        },
        delProduct(product) {
            const index = this.totallingTarget.products.indexOf(product);
            this.totallingTarget.products.splice(index, 1);
        },
        productListFilter(product) {
            // 未登録商品を表示するかどうか & メイン商品選択時は表示しない
            if (this.isTotallingTargetUsed && product.is_totalling_targeted) {
                return false;
            }
            // 選択済みの商品は表示しない
            return !this.totallingTarget.products.some(totallingTarget => totallingTarget.id == product.id);
        },
        async updateTotallingTargetItem() {
            this.$store.dispatch('loading', true);

            try {
                if (this.totallingTargetId > 0) {
                    await this.axios.put(`/api/totallingTargets/${this.totallingTargetId}`, { totalling_target: this.totallingTarget });
                } else {
                    await this.axios.post(`/api/totallingTargets`, { totalling_target: this.totallingTarget });
                }
            } finally {
                this.$store.dispatch('loading', false);
            }

            this.$emit('update-totalling-target-item');
            this.$emit('modalClosed');
        },
    }
}
</script>

<style scoped lang="sass">
.connectionContainer
    // TODO: Card Layoutをcomponent化する
    height: 100%
    width: 100%
    margin: 0
    padding: 10px
    display: inline-grid
    grid-template-rows: 40px 1fr 40px
    grid-row-gap: 10px
    .connectionHeader
        display: flex
        align-items: center
        font-size: 1.5rem
        .searchInputText
            display: block;
            padding: 10px;
            width: 30%;
            min-width: 250px;
            margin-right: 15px;
    .connectionContents
        display: inline-grid
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr)
        grid-template-rows: minmax(0, 1fr)
        grid-column-gap: 10px
        overflow: auto
        .productListPanel
            border: 1px solid $grayColor
            padding: 15px
        .totallingTargetList
            display: inline-grid
            grid-template-columns: 1fr
            grid-row-gap: 10px
            grid-template-rows: 44px 1fr
            &__title
                font-size: 1.5rem
                color: $grayColor
                padding: 15px 5px 10px
            .productList
                font-size: 1.5rem
                overflow-y: scroll
                width: 100%
                &__wrap
                    width: 100%
                &__list
                    display: flex
                    flex-wrap: wrap
                &__item
                    display: flex
                    flex-wrap: nowrap
                    justify-content: space-between
                    align-items: center
                    overflow: hidden
                    margin: 2px
                    padding: 7px 2px
                    width: 100%
                    background: #f5f5f5
                    white-space: nowrap
                    position: relative
                    &-handle
                        color: $whiteColor
                        opacity: 0
                        cursor: grab
                    &-id
                        flex: 0 0 70px
                    &-name
                        flex: 1 1 auto
                        overflow: hidden
                        min-width: 0
                    &-action
                        flex: 0 0 27px
                        color: $whiteColor
                        opacity: 0
                        cursor: pointer
                &__list:not(.draged) .productList__item:hover
                    background: $mainColor
                    color: $whiteColor
                    transition: 0.2s ease-out
                    .productList__item-handle
                        opacity: 1
                        transition: all 0.8s
                    .productList__item-action
                        opacity: 1
                        transition: all 0.8s
                .flip-list-move
                    transition: transform 0.5s
                .ghost
                    opacity: 0.5
                    background: #c8ebfb


        .productListPanel::v-deep
            .productList__item
                .productItemAction
                    opacity: 0
                    color: $whiteColor
                &:hover
                    .productItemAction
                        opacity: 1
                        transition: all 0.8s
            .selectProductList__isTotallingTargetUsed
                display: flex
                align-items: center
                height: 40px
                font-size: 1.5rem
    .connectionFooter
        display: flex
        justify-content: center
</style>
